module.exports = __webpack_public_path__ + "img/arrow-up-s-line.a2f86fa7.svg";